/**
 * 크리에이터 찾기(인플루언서 목록) 고르개의 값 — 채널 · 정렬 · 신규 발굴 기간 · 지표.
 *
 * 목록 화면(`sections/influencer/constants/influencer-list-filters`)과 「질문 → 화면」 조건표(`ask-screens`)가 함께 읽는 한 벌이다.
 */

/** 채널 — 늘 하나가 골라져 있다(「전체」 없음) */
export const CREATOR_CHANNEL_VALUES = ['instagram', 'tiktok', 'youtube', 'x', 'threads'] as const;

/** 정렬 — 관련도순은 키워드가 있을 때만 따로 선다(`RELEVANCE_SORT_OPTION`) */
export const SORT_OPTIONS = [
  { value: 'recent30Reaction', label: '최근 30일 총반응순' },
  { value: 'recent30View', label: '최근 30일 총조회순' },
  { value: 'recentActivity', label: '최근 활동성순' },
  { value: 'followers', label: '팔로워순' },
  { value: 'engagementRate', label: '팔로워당 반응순' },
] as const;

/** 신규발굴 기준 기간(일) 옵션: 인플루언서 문서 생성시간 기준 */
export const NEW_DISCOVERY_DAY_OPTIONS = [7, 14, 30, 90];

/**
 * 지표 필터 정의. `key`는 ES range 필드(`INFLUENCER_LIST_STAT_FIELDS`)와 1:1로 대응 —
 * 필터·정렬·카드 표시 모두 일일 배치가 채운 `stats30d` 값을 쓴다.
 */
export const STAT_FILTER_DEFS = [
  { key: 'view', label: '조회수' },
  { key: 'er', label: '팔로워당 반응 (%)' },
  { key: 'like', label: '좋아요' },
  { key: 'comment', label: '댓글' },
  { key: 'share', label: '공유' },
  { key: 'saved', label: '저장' },
  { key: 'recent30', label: '포스팅' },
] as const;
